<template>
  <div class="basic-information">
    <el-input type="textarea" id="minCopy" v-model="mindDataText" />
    <div class="js-mind">
      <div id="jsmind_container" />
    </div>
  </div>
</template>
<script>
import mindMap from '@/assets/jsmind/jsmindBase.js';

export default {
  props: {
    linkId: {
      type: Number,
      required: true
    },
    countryId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mindDataText: '',
    };
  },
  created() {
    this.$nextTick(() => {
      // 思维导图
      mindMap('jsmind_container', {
        table: 'crm',
        link_id: this.linkId,
        cid: this.countryId,
        vue: this
      });
    });
  }
};
</script>
